import { render, staticRenderFns } from "./reason_delete.vue?vue&type=template&id=48d0d204&"
import script from "./reason_delete.vue?vue&type=script&lang=js&"
export * from "./reason_delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports